const o = {
  userEnterRace:
    "function userEnterRace(string memory raceid, uint hid) external",
  enterRace: "function userEnterRace(string memory raceid, uint hid) external",
};

export default o;
